export const OVERVIEW_SUMMARY_METRIC_ORDER = [
  'reach',
  'engagement',
  'followers',
  'posts_count',
] as const;

export type OverviewSummaryMetricKey =
  (typeof OVERVIEW_SUMMARY_METRIC_ORDER)[number];

export const OVERVIEW_SUMMARY_METRIC_LABELS: Record<
  OverviewSummaryMetricKey,
  string
> = {
  reach: 'Reach',
  engagement: 'Engagement',
  followers: 'Followers',
  posts_count: 'Posts',
};
